import AspectClearableLabel from "./AspectClearableLabel";
import { AspectDivider } from "./AspectDivider";

// AJB: need an apply button to close the menu?
export default function AspectToggle({
  label,
  icon,
  isSelected,
  onChange,
}: {
  label: string;
  icon: React.ReactNode;
  isSelected: boolean;
  onChange: (isSelected: boolean) => void;
}) {
  return (
    <>
      <AspectDivider />
      <AspectClearableLabel
        onClick={() => onChange(!isSelected)}
        icon={icon}
        label={label}
        selectedValues={isSelected ? [label] : undefined}
      />
    </>
  );
}
